import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy as orderByFn, query } from 'firebase/firestore';
import { db } from '../config/FirebaseConfig';

export default function useFirestoreCollection(collectionName, options = {}) {
  const { orderBy } = options;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    const colRef = collection(db, collectionName);
    const q = orderBy ? query(colRef, orderByFn(orderBy.field, orderBy.direction || 'asc')) : colRef;

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const items = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setData(items);
        setError(null);
        setLoading(false);
      },
      (snapshotError) => {
        console.error(`Error escuchando colección ${collectionName}:`, snapshotError);
        setError(snapshotError);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [collectionName, orderBy?.field, orderBy?.direction]);

  return { data, loading, error };
}
